<script setup>
import QTIndu from "@/assets/images/educationAndTraning/QTIndu.png";
</script>

<template>
  <div class="space-y-2">
    <img :src="QTIndu" alt="QTIndu Image" class="h-20 object-contain" />
    <p>
      <a
        href="https://qt.eu/news/2023/2023-01-18_qtindu-making-european-industry-quantum-ready"
        class="gradientText hoverUnderline"
      >
        QTIndu: Quantum Technology Courses for Industry</a
      >
      will develop targeted training programs to upskill professionals across
      many industries. These include business sectors such as pharmaceuticals,
      medical sensing, telecommunication, cybersecurity, and logistics, where QT
      is rapidly making an impact in how companies function. QTIndu is funded by
      5.6Mil Euros through the European Union’s Digital Europe Programme under
      grant agreement no. 101100757.
    </p>
  </div>
</template>
